import { useQuery as _useQuery, NetworkStatus } from '@apollo/client'
import { prop } from 'ramda'
import React from 'react'
import moment from 'moment'

import { DEFAULT_FETCH_POLICY } from '../_config/generateClient'
import { getQueryName } from './graphql'
import { hasValue } from '../../helpers/value'

const POLL_INTERVAL_MINUTE_BREAK = 10

export const useQuery = (QUERY, { flexiblePollInterval, ...props }) => {
  const [init, setInit] = React.useState(moment())
  const [pollInterval, setPollInterval] = React.useState(flexiblePollInterval)
  const { startPolling, stopPolling, loading, data, ...state } = _useQuery(QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: DEFAULT_FETCH_POLICY,
    pollInterval,
    ...props
  })

  if (flexiblePollInterval > 0) {
    const minutesSinceStart = moment().diff(init, 'minutes')
    if (minutesSinceStart >= POLL_INTERVAL_MINUTE_BREAK) {
      setInit(moment())
      setPollInterval(pollInterval * 2)
    }
  }

  const queryName = getQueryName(QUERY)
  const status = NetworkStatus[state.networkStatus]
  const value = prop(queryName, data || {})
  const hasData = hasValue(value)
  const initialLoading = !hasData && loading
  const isRefetching = value !== undefined && loading
  const isFetchingMore = hasData && loading && status === 'fetchMore'
  const empty = !props.skip && !hasData && !loading && status !== 'fetchMore'

  return { ...state, empty, status, data, isRefetching, isFetchingMore, loading: initialLoading }
}
